import { create } from "./incident_activities.create";

export const incident_activities = {
  icon: "FmdBad",
  name: "incident_activities",
  create,
}